export default {
  SIGN_IN: process.env.REACT_APP_SIGN_IN_URL || "",
  ACCOUNTS_ADMIN: process.env.REACT_APP_ACCOUNTS_ADMIN_URL,
};
